export default __webpack_public_path__ + "static/media/Arrow.c3e813b2.svg";